// extracted by mini-css-extract-plugin
export default {"pagination":"pagination--ABfrM","pagination__info":"pagination__info--PaHjK","pagination__cta":"pagination__cta--_8Xiw"};